import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from '@app/core/services/custom-services/localstorage.service';
import { TenantService } from '@app/core/services/http-services/common/tenant.service';
import { ITenantInformationDTO } from '@app/core/models/tenantInformationDTO.model';
import { _, TranslatePipe } from "@ngx-translate/core";
import { FormFieldComponent } from '@progress/kendo-angular-inputs';

import { LabelComponent } from '@progress/kendo-angular-label';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { ConfirmationDialogComponent } from '@app/core/components/confirmation-dialog/confirmation-dialog.component';

_('App.Tenant');
_('App.ChangeTenant');

@Component({
    selector: 'app-select-tenant',
    template: `
  <kendo-formfield>
    @if (showLable) {
      <kendo-label
        [text]="label | translate" style="width:100%">
        <kendo-dropdownlist
          [data]="tenants"
          textField="id"
          valueField="id"
          [loading]="loading"
          [valuePrimitive]="true"
          [(value)]="selectedTenant"
          style="width:100%"
          (selectionChange)="onChangedVal()"
          >
        </kendo-dropdownlist>
      </kendo-label>
    }
  </kendo-formfield>
  
  @if (tennatChanged) {
    <app-confirmation-dialog
      [msg] = "confirmationMsg"
      [title]="confirmationMsgTitle"
      (conformationDialogCloseEvent) = "confirmChangeTenant($event)">
    </app-confirmation-dialog>
  }
  `,
    styles: [
        ':host { width: 100%; }'
    ],
    imports: [FormFieldComponent, LabelComponent, DropDownListComponent, TranslatePipe, ConfirmationDialogComponent]
})
export class SelectTenantComponent implements OnInit {
  tenants: ITenantInformationDTO[] = [];
  loading:boolean = true;
  tennatChanged: boolean = false;
  defaultTenant:string = null;

  @Input() label:string = 'App.Tenant';
  @Input() showLable:boolean = false;
  @Input() selectedTenant:string = 'ForestX';

  // confirmation dialog
  confirmationMsg: string = 'App.ChangeTenant';
  confirmationMsgTitle: string = 'App.RemoveConfirmTitle';

  constructor(private readonly tenantService: TenantService
    , private readonly localStorage:LocalStorageService) {
  }

  ngOnInit(): void {
    this.loadTenant();
  }

  private loadTenant() {
    this.tenantService.getTenants().subscribe(t => {
      this.tenants = t;
      this.selectedTenant = this.localStorage.getItem(LocalStorageService.tennatKey) ?? this.selectedTenant;
      this.defaultTenant = this.selectedTenant;
      this.loading = false;
    });
  }

  onChangedVal() {
    this.tennatChanged = true;
  }

  confirmChangeTenant(confirmChange:boolean) {
    this.tennatChanged = false;
    if (confirmChange) {
      this.localStorage.setItem(LocalStorageService.tennatKey, this.selectedTenant);
      window.location.href = window.location.origin;
    } else {
      this.selectedTenant = this.defaultTenant;
    }
  }
}
